import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = 'Caricamento in corso…' }: LoadingStateProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 8,
        color: 'text.secondary',
      }}
    >
      <CircularProgress color="secondary" size={32} />
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
}
